<template>
  <div v-if="store.loaded" ref="mediaRef" :class="['media-wrapper', {'media-wrapper-mobile': store.showMobile}]" @scroll="setBackgroundSize">
    <div class="media-container">
      <template v-for="item in mediaArr" :key="item.id">
        <media-block-item :item="item" class="mb-bkg-resize"/>
      </template>
    </div>
  </div>
</template>
  
<script lang="ts">
import { defineComponent, ref, Ref } from 'vue'
import { useMainStore, typeMediaItem } from '../store'
import MediaBlockItem from './MediaBlockItem.vue'
export default defineComponent({
  name: "MediaBlock",
  components: {
    MediaBlockItem
  },
  props: {
    category: {
      type: String || undefined,
      default: undefined
    },
    deltaY: {
      type: Number,
      default: 0
    }
  },
  watch: {
    $route (to, from) {
      if (to.path !== from.path) {
        setTimeout(() => {
          this.setBackgroundSize()
        }, 0)
      }
    },
    deltaY (newVal, oldval) {
      if (newVal !== oldval) {
        this.scrollMedia(this.deltaY)
      }
    }
  },
  data() {
    return {
      store: useMainStore(),
      media: [] as unknown as typeMediaItem[]
    };
  },
  computed: {
    mediaArr() : typeMediaItem[] {
      return this.store.getMedia(this.category)
    }
  },
  methods: {
    setBackgroundSize () {
      if (!this.mediaRef) return
      const mediaBlocks = this.mediaRef.querySelectorAll('.mb-bkg-resize') as unknown as HTMLElement[]
      const middleOfScreen = this.mediaRef.getBoundingClientRect().height/2 // середина блока media-wrapper по Y
      let middleOfElement: number
      let coord: DOMRect
      let ratio : number
      mediaBlocks.forEach(el => {
        coord = el.getBoundingClientRect() // Координаты media-container
        middleOfElement = coord.top + coord.height/2
        ratio = 1 - Math.abs(middleOfScreen - middleOfElement)/500 // 500 - высота зоны срабатывания
        if (ratio < 0) { ratio = 0 } // если элемент вне зоны срабатывания
        el.style.backgroundSize = 100 + 30*ratio + '%' // 30 – процент увеличения
      })
    },
    scrollMedia (deltaY: number) {
      if (!this.mediaRef) return
      this.mediaRef.scrollTop += deltaY
    }
  },
  setup() {
      const mediaRef: Ref<HTMLElement | null> = ref(null)
      return {
        mediaRef
      }
  },
  mounted() {
    this.setBackgroundSize()
    window.addEventListener('resize', this.setBackgroundSize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setBackgroundSize);
  },
})
</script>
  
<style scoped>
.media-wrapper {
  position: absolute;
  top: -1rem;
  right: -1rem;
  height: 105vh;
  width: inherit;
  overflow: hidden;
  transform: rotate(2deg);
  scroll-behavior: smooth;
}

.media-wrapper::-webkit-scrollbar {
  display: none;
}

.media-container {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
  grid-template-rows: auto;
  min-height: 100%;
  align-content: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem 0;
}

/* ================ */
/* Мобильная версия */
/* ================ */
.media-wrapper-mobile {
  pointer-events: all;
  overflow: auto;
  transform: rotate(0);
  /* height: 100dvh !important; */
  top: 0;
  left: 0;
  padding: 6rem 1rem 1rem 1rem;
}
</style>
  